/**
 * Exchange Enum - Matching Rust Exchange enum order
 * Use these constants instead of strings for type safety
 */

// Exchange enum as const for type safety
export const Exchange = {
  Upbit: 0,
  Bithumb: 1,
  Coinone: 2,
  Binance: 3,
  HTX: 4,
  GateIO: 5,  // Note: 'Gate.io' -> GateIO for valid JS identifier
  KuCoin: 6,
  OKX: 7,
  MEXC: 8,
  Bybit: 9,
  Bitget: 10,
} as const;

// Type derived from the const object
export type ExchangeIndex = typeof Exchange[keyof typeof Exchange];

// Helper to get exchange name from index
export function getExchangeName(index: ExchangeIndex): string {
  const names = [
    'Upbit',    // 0
    'Bithumb',  // 1
    'Coinone',  // 2
    'Binance',  // 3
    'HTX',      // 4
    'GateIO',   // 5
    'KuCoin',   // 6
    'OKX',      // 7
    'MEXC',     // 8
    'Bybit',    // 9
    'Bitget',   // 10
  ];
  return names[index] || 'Unknown';
}

// Helper to check if a number is a valid exchange index
export function isValidExchangeIndex(index: number): index is ExchangeIndex {
  return index >= 0 && index <= 10;
}

// All exchange indices as an array
export const ALL_EXCHANGES = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10] as const;